import React from "react";
import { SEO, MainLayout, SignupVerification } from "../../../components";

const SignupVerificationPage = () => {
  return (
    <>
      <SEO title="Verification Code" />
      <MainLayout>
        <SignupVerification />
      </MainLayout>
    </>
  );
};

export default SignupVerificationPage;
